<template>
    <v-wait for="loading defects" class="layout column fill-height">
        <template slot="waiting">
            <vcl-list height="200"></vcl-list>
        </template>
        <v-card
            class="ma-1"
            v-for="defectsForUnit in groupedDefects"
            :key="defectsForUnit.unitNumber"
        >
            <v-list>
                <v-subheader
                    class="clickable"
                    @click="$router.push('/units/' + defectsForUnit.unitId)"
                >
                    <div style="min-width:40px">
                        <v-icon>build</v-icon>
                    </div>
                    <unit-label :value="defectsForUnit.defects[0].defects[0]"></unit-label>
                </v-subheader>
                <div v-for="defectsForEdn in defectsForUnit.defects" :key="defectsForEdn.ednNumber">
                    <v-subheader>
                        <v-chip>{{defectsForEdn.ednNumber}}</v-chip>
                    </v-subheader>
                    <v-list-item
                        v-for="defect in defectsForEdn.defects"
                        :key="defect.id"
                        :to="disabled || defect.isComplete ? {} : { query: { defectId: defect.id, initiateFrom: 'defects' } }"
                        :class="classes(defect)"
                    >
                        <v-list-item-content>
                            <v-layout row wrap class="mx-0">
                                <div>
                                    {{defect.lineNumber ? defect.lineNumber + ': ' : ''}} {{defect.description}}
                                    <br/>
                                    <span class="caption" v-if='defect.rating'>{{defect.rating.name}}</span>
                                </div>
                            </v-layout>
                        </v-list-item-content>
                        <v-list-item-action>
                            <move-menu
                                :value="defect"
                                type="defect"
                                v-if="!disabled && !defect.isComplete"
                                :max="maxDate(defect)"
                                @move="moveDefectToDate($event.service, $event.date)"
                            ></move-menu>
                        </v-list-item-action>
                    </v-list-item>
                </div>
            </v-list>
        </v-card>

        <div class="subtitle-1" v-if="!defects || defects.length == 0">No defects to action today</div>
    </v-wait>
</template>
<script>
  import {VclList} from 'vue-content-loading';
  import {GarageLocationStore} from '@/stores/GarageLocationStore';
  import UnitLabel from '@/components/Units/UnitLabel.vue';
  import DefectNoticesClient from '@/components/DefectNotices/DefectNoticesClient.vue';
  import MoveMenu from '@/components/Calendar/Move/MoveMenu.vue';
  import Controls from './Controls.vue';
  import DefectHelper from '@/lib/DefectHelper';
  import {Event} from '@/plugins/bus';
  import * as _ from 'lodash';
  import moment from 'moment';
  import { DateFormat } from '@/plugins/date-filter';

  export default {
    mixins: [Controls, DefectNoticesClient],
    components: {
      MoveMenu,
      VclList,
      UnitLabel
    },
    data() {
      return {
        defects: []
      };
    },
    computed: {
      querystring() {
        if (!this.params) {
          return '';
        }
        return (
          '?' +
          Object.keys(this.params)
            .filter(key => !!this.params[key])
            .map(key => key + '=' + this.params[key])
            .join('&')
        );
      },
      disabled() {
        const g = GarageLocationStore.data.userGarage;
        const garages = GarageLocationStore.data.userGarages;
        return (!this.userIsFleetManager) && (!this.userIsWorkshopManagerInGarage(g, garages));
      },
      params() {
        return {
          from: this.from,
          to: this.to,
          garageLocationId: GarageLocationStore.data.userGarage
        };
      },
      groupedDefects() {
        function groupByEdn(defects) {
          return _.chain(defects)
            .groupBy('ednNumber')
            .map((value, key) => ({ednNumber: key, defects: value}))
            .value();
        }

        return _.chain(this.defects)
          .groupBy('unitNumber')
          .map((value, key) => ({unitNumber: key, unitId: value[0].unitId, defects: groupByEdn(value)}))
          .value();
      }
    },
    async mounted() {
      await this.getDefects();
      this.$bus.$on(Event.GarageSelected, this.getDefects);
      this.$bus.$on(Event.DefectCompleted, this.handleDefectCompleted);
      this.$bus.$on(Event.DefectMoved, this.handleDefectCompleted);
      this.$bus.$on(Event.DefectPhotoDeleted, this.handleDefectCompleted);
    },
    destroyed() {
      this.$bus.$off(Event.GarageSelected, this.getDefects);
      this.$bus.$off(Event.DefectCompleted, this.handleDefectCompleted);
      this.$bus.$off(Event.DefectMoved, this.handleDefectCompleted);
      this.$bus.$off(Event.DefectPhotoDeleted, this.handleDefectCompleted);
    },
    watch: {
      async current(val) {
        await this.getDefects();
      },
      async userGarage(val) {
        await this.getDefects();
      }
    },
    methods: {
      async handleDefectCompleted() {
        await this.getDefects();
      },
      async getDefects() {
        try {
          this.$wait.start('loading defects');
          this.$wait.end('loading data');
          const response = await this.$api.get(`defects${this.querystring}`);
          this.defects = response.data.data;
        } catch (error) {
          this.$toast.error('There was an error getting defects');
          this.defects = [];
        } finally {
          this.$wait.end('loading defects');
          this.$wait.end('loading data');
        }
      },
      classes(defect) {
        return {
          completed: !defect.isComplete,
          sweptForward: !defect.isComplete && defect.sweptForwardByScheduler,
          'past-due': !defect.isComplete && defect.isPastDue
        };
      },
      async moveDefectToDate(defect, date) {
        await this.moveDefect(defect.id, {scheduledDate: date});
      },
      maxDate(defect) {
        var mxDate  = moment();
        var category = (defect.category) || { defaultScheduleMonths: 3};
        var categoryMaxDate = moment(defect.receivedDate).add(category.defaultScheduleMonths, 'M');

        if (moment(categoryMaxDate) > moment(mxDate)) { mxDate = moment(categoryMaxDate); }
        if (defect.extensionDate) { mxDate = (moment(defect.extensionDate) > moment(mxDate) ? moment(defect.extensionDate) : moment(mxDate)); }

        return mxDate.format(DateFormat.Canonical);
      }
    }
  };
</script>
